import React, { useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import { Evento } from "../../components/evento";
import { EventoDatos } from "../../components/eventoDatos";
import { apiUrlGestor, apiUrlAced, apiUrlSaveSpot, urlRoot} from "../../global";
import { Form } from "../../components/forms";
import { FormSend } from "../../components/formSend";
import { FormTutor } from "../../components/formsTutor";
import Footer from "../../components/Footer";
import { Navbar } from "../../components/NavbarSimple";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";

function Eventos() {
  const { eventId } = useParams();
  const [evento, setEvento] = useState([]);
  const [eventoPrivado, setEventoPrivado] = useState([]);
  const [eventoTipo, setEventoTipo] = useState([]);
  const [claveCampus, setClaveCampus] = useState(null);
  const [nivelEvent, setNivelEve] = useState(null);
  const [areaEvent, setAreaEve] = useState(null);
  const [registrado, setRegistrado] = useState(false);
  const [campusData, setCampusData] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [BtnShow, setBtnShow] = useState(true);
  const [__tituloEvento, settituloEvento] = useState("");
  const [campusSoad, setCampusSoad] = useState([]);
  //ESTADOS PARA FORMULARIO
  const [mostrarFormulario, setMostrarFormulario] = useState(null);
  const [eventoNormal, seteventoNormal] = useState(true);
  const [eventoExterno, seteventoExterno] = useState(false);
  const [imageError, setImageError] = useState(true);
  const [isLoading, setIsLoading] = useState(false); //Variable para el loading
  let navigate = useNavigate();

  //const [fetchDone, setFetchDone] = useState(false);

  const handleForm = () => setMostrarFormulario(null);

  //Buscamos si la URL tiene un gracias
  const currentUrl = window.location.href;
  const isThankYouPage = currentUrl.includes("/gracias");
  //Mensaje gracias
  const urlSearchParams = new URLSearchParams(currentUrl.split("?")[1]);
  const mensajePersonalizado = urlSearchParams.get("g");

  //console.log('LocalStorage keys:', Object.keys(localStorage))

  //console.log(isThankYouPage);

  //ANCLA
  if (window.location.hash === "#confirmacion") {
    // Encontrar el elemento al que deseas desplazarte
    const confirmationElement = document.getElementById("confirmacion");

    // Realizar el desplazamiento suave hasta el elemento
    if (confirmationElement) {
      confirmationElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  useEffect(() => {
      setMostrarFormulario("form")
  }, []); // El segundo argumento, un array vacío, asegura que se ejecute solo una vez

  useEffect(() => {
    // Verificar si ya se ha realizado la consulta previamente
    //setClaveCampus("test");
    //debugger
    if (evento.length === 0) {

      //var idCamp = evento[0].event.id_campus.replace("FCOE_", "");

      var url=apiUrlGestor + "obtenerEventos.php?match=All&url=" + eventId+"&ca="+localStorage.getItem("campusStorage")
      console.log(url);
      fetch(apiUrlGestor + "obtenerEventos.php?match=All&url=" + eventId)
        .then((response) => response.json())
        .then((data) => {
//          debugger
          //console.log("aqui");
          //console.log(data.events);
          if (data.events && data.events.length > 1) {
            const eventAtIndex1 = data.events[1];
            if (eventAtIndex1 && eventAtIndex1.type) {
              navigate("/" + eventId);
              return null;
            }
          }
          if(data.events[0].event.nivel==="07"){
            navigate("/sedes/evento/" + eventId);
            return null;
          }
          if(data.events[0].event.nivel==="09"){
            navigate("/internacional/evento/" + eventId);
            return null;
          }
          //LABEL:
          setEvento(data.events);
          setEventoPrivado(data.events[0].event.privado);
          setEventoTipo(data.events[0].event.tipo_evento);

          //ENVIAMOS OTRO DATO POR SEPARADO
          settituloEvento(data.events[0].event.title);
          //const claveCampus = data.events[0].event.keywords[0];
          var claveCampusMultiple = data.events[0].event.fcoe;
          if (localStorage.getItem("campusStorage") && claveCampusMultiple === "") {
           // console.log("entro al local");
            claveCampusMultiple= "FCOE_" + localStorage.getItem("campusStorage");
          }

          var campuses = data.events[0].event.campuses.length;
          if (campuses > 1 && localStorage.getItem("campusStorageName"))
            claveCampusMultiple= "FCOE_" + localStorage.getItem("campusStorage");

//          console.log("claveCampusMultiple = "+claveCampusMultiple);


          const claveCampus = claveCampusMultiple
          const tipoEvento = data.events[0].event.tipo_evento;
          const experiencia = data.events[0].event.experience;

          if (experiencia==="linea")
            seteventoNormal(true);

          if (tipoEvento==="34247221930995"){
            seteventoExterno(true);
           // setMostrarFormulario(false);
            //seteventoNormal(false);
        }

          if (claveCampus === "FCOE_VC") {
            if (localStorage.getItem("campusStorage")) {
              //let arryCampusKey = ["FCOE_" + localStorage.getItem("campusStorage"),];
              let arryCampusKey =
                "FCOE_" + localStorage.getItem("campusStorage");
              setClaveCampus(arryCampusKey);
            } else setClaveCampus("FCOE_A");
          } else setClaveCampus(claveCampus);

          const nivelEvent = data.events[0].event.nivel;
          setNivelEve(nivelEvent);

          const area = data.events[0].event.area;
          setAreaEve(area);
        })
        .catch((error) => {
          console.log("entro al error");
          console.log(error);
        });
    }
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1200);
  }, [evento, eventId, navigate]);


  //DATOS DE CAMPUS ACED
  useEffect(() => {
    setCampusSoad("");
    if (claveCampus) {
//      console.log(nivelEvent);
      var gradeCampus = "profesional";
      if (nivelEvent === "03") gradeCampus = "prepatec";

      const claveCampusString = String(claveCampus);
      const keyCamp = claveCampusString.replace("FCOE_", "");
      if (keyCamp === "VC") gradeCampus = "otro";

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ grade: gradeCampus, sf_key: keyCamp }),
      };
      // Realizar la solicitud Fetch aquí
      fetch(apiUrlAced + "campuses/search", options)
        .then((response) => response.json())
        .then((datos) => {
          setCampusData(datos.data);

          //debugger
          if (!datos.data[0].sf_key) {
            // El valor de datos.data[0].sf_key no existe o es falsy
            // Puedes tomar alguna acción aquí, si es necesario
            setCampusSoad(keyCamp);
          } else {
            // El valor de datos.data[0].sf_key existe y no es falsy
            setCampusSoad(datos.data[0].sf_key);
          }
        });
    }
  }, [claveCampus, nivelEvent]);
  //END DATOS CAMPUS ACED
  const img = new Image();
  img.src = `${process.env.PUBLIC_URL}/img/banners/banner-profesional-${campusSoad}.webp`;

  img.onerror = () => {
    setImageError(true);
  };

  img.onload = () => {
    setImageError(false);
  };
  //DATOS DE AREA ACED
  useEffect(() => {
    if (areaEvent) {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };
      // Realizar la solicitud Fetch aquí
      fetch(apiUrlAced + "areas/" + areaEvent, options)
        .then((response) => response.json())
        .then((datos) => {
          setAreaData(datos.data);
          // setFetchDone(true); // Marcar la solicitud como completada
        });
    }
  }, [areaEvent]);
  //DATOS DE AREA ACED

  const eventoRegistrado = () => {
    setRegistrado(true);
  };

  const sendConfirmEmail = (event) => {
    console.log("send email");
    const msjSend = document.getElementById("msjSend");
    msjSend.innerText = "Enviando...";

    const tipoEnvio = event.target.id;
    console.log(tipoEnvio);

    var emailSendValidate = localStorage.getItem("emailSendInfo");
    var utm_correo_padre = localStorage.getItem("utm_correo_padre");
    var credentialsS;

    //const referSend=window.location.href
    credentialsS = {
      utm_correo_padre: utm_correo_padre,
      utm_nombre_padre: "SaveSpot",
    };
    const credentials = credentialsS;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    };

    fetch(
      apiUrlSaveSpot +
        "core/email-services/validate-data-email/" +
        emailSendValidate,
      options
    )
      .then((resp) => {
        localStorage.removeItem("emailSendInfo");
        // console.log(resp)
        //return resp.json()
        msjSend.innerText = "";
        document.getElementById("msjSendRequest").style.display = "block";
        localStorage.removeItem("emailSendInfo");
        localStorage.removeItem("utm_correo_padre");
        document.getElementById("smjThank").style.display = "none";
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("emailSendInfo");
      });
    
    };

  var ruta = window.location.origin;
  var palabra = "localhost";

  var index = ruta.indexOf(palabra);
  if (index < 0) ruta = ruta + "/" + urlRoot;

  useEffect(() => {

    if (isThankYouPage) {
      setBtnShow(false); // Actualiza el estado de btnShow a false

    }
  }, [isThankYouPage]);
  return (
    <div>
      {isLoading ? (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      ) : (
        <div>
          <Navbar tituloEvento={__tituloEvento} 
          nivel={nivelEvent === "03" ? 'prepatec' : 'profesional'} />
          <Grid
            item
            xs={12}
            sx={{
              mb: 6,
              backgroundImage: `url(${
                imageError
                  ? `${process.env.PUBLIC_URL}/img/banners/banner-default.webp`
                  : `${process.env.PUBLIC_URL}/img/banners/banner-profesional-${campusSoad}.webp`
              })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: `1px 30px 30px 10px #bfbfbf`,
              height: 140,
              "@media (max-width: 900px)": {
                height: 96,
              },
            }}
          >
            {" "}
          </Grid>

          <Evento
            EventoNormal={eventoNormal}
            Evento={evento}
            Registrado={registrado}
            InfoCampus={campusData}
            InfoArea={areaData}
            btnshow={BtnShow}
            EventoExterno={eventoExterno}
            tipoEvento={eventoTipo}
            eventoPrivado={eventoPrivado}
          />
          <br></br>
          <br></br>
          {!eventoExterno && (
            <>
              <Grid container spacing={4}>
                <Grid item md={1} xs={1}></Grid>
                <Grid
                  className="borderForm"
                  item
                  md={10}
                  xs={11}
                  sx={{
                    display: { xs: "flex", md: "block" },
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid item md={12} xs={11}>
                    <Grid
                      item
                      xs={12}
                      sx={{ pb: 2, display: isThankYouPage ? "none" : "block" }}
                    >
                      <h2 id="btnValidaR" style={{ color: "#109AFF" }}>
                        ¡Regístrate aquí!
                      </h2>
                    </Grid>
                    {isThankYouPage ? (
                      <div id="confirmacion">
                        <Grid container spacing={12}>
                          <Grid item xs={12}>
                            <h2 id="smjThank">
                              {mensajePersonalizado === "1#confirmacion"
                                ? "¡Gracias por tu registro!"
                                : mensajePersonalizado === "2#confirmacion"
                                ? "¡Hola de nuevo!"
                                : mensajePersonalizado === "3#confirmacion"
                                ? "¡Gracias por tu interés!"
                                : "¡Gracias por tu interés!"}
                            </h2>
                            {mensajePersonalizado && (
                              <div>
                                {mensajePersonalizado === "1#confirmacion" && (
                                  <p>
                                    Te sugerimos seguir explorando{" "}
                                    <a href={"/"+urlRoot}>
                                      nuestros otros eventos disponibles
                                    </a>
                                    . ¡Esperamos verte pronto!
                                  </p>
                                )}
                                {mensajePersonalizado === "2#confirmacion" && (
                                  <>
                                    <p id="msjSend">
                                      Hemos realizado tu registro con la
                                      información que tenemos asociada a tu
                                      correo, ¡gracias por tu interés! Si deseas
                                      recibir aparte el detalle de tus datos
                                      relacionados
                                      <strong
                                        style={{
                                          color: "blue",
                                          cursor: "pointer",
                                        }}
                                        onClick={sendConfirmEmail}
                                        id="enviarCorreoFR"
                                      >
                                        {" "}
                                        da clic aquí
                                      </strong>
                                      , o también puedes encontrarnos en nuestro{" "}
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={
                                          nivelEvent === "03"
                                            ? "https://admision.tec.mx/contact-hub-prepatec/home"
                                            : "https://admision.tec.mx/contact-hub/home"
                                        }
                                      >
                                        <b>Contact Hub</b>
                                      </a>
                                      . <br></br>
                                      <br></br>
                                      Te sugerimos seguir explorando{" "}
                                      <a href={"/"+urlRoot}>
                                        nuestros otros eventos disponibles
                                      </a>
                                      . ¡Esperamos verte pronto!
                                    </p>

                                    <p
                                      id="msjSendRequest"
                                      style={{ display: "none" }}
                                    >
                                      <h3>¡Listo!</h3>Hemos enviado los datos
                                      relacionados a tu correo electrónico.
                                      Recuerda que puedes encontrarnos en
                                      nuestro{" "}
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={
                                          nivelEvent === "03"
                                            ? "https://admision.tec.mx/contact-hub-prepatec/home"
                                            : "https://admision.tec.mx/contact-hub/home"
                                        }
                                      >
                                        <b>Contact Hub</b>
                                      </a>
                                      , o ver más información en{" "}
                                      <a href="https://tec.mx/es">
                                        <b>Tec.mx</b>
                                      </a>
                                      .
                                    </p>
                                  </>
                                )}
                                {mensajePersonalizado === "3#confirmacion" && (
                                  <>
                                    <p id="msjSend">
                                      Hemos registrado a tu hijo(a) como
                                      asistente, y enviamos una confirmación a
                                      su correo. Si deseas recibir aparte el
                                      detalle de los datos asociados a tu correo
                                      <strong
                                        style={{
                                          color: "blue",
                                          cursor: "pointer",
                                        }}
                                        onClick={sendConfirmEmail}
                                        id="enviarCorreoFRP"
                                      >
                                        {" "}
                                        da clic aquí
                                      </strong>
                                      , o también puedes encontrarnos en nuestro{" "}
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={
                                          nivelEvent === "03"
                                            ? "https://admision.tec.mx/contact-hub-prepatec/home"
                                            : "https://admision.tec.mx/contact-hub/home"
                                        }
                                      >
                                        <b>Contact Hub</b>
                                      </a>
                                      . <br></br>
                                      <br></br>
                                      Te sugerimos seguir explorando{" "}
                                      <a href={"/"+urlRoot}>
                                        nuestros otros eventos disponibles
                                      </a>
                                      . ¡Esperamos verte pronto!
                                    </p>

                                    <p
                                      id="msjSendRequest"
                                      style={{ display: "none" }}
                                    >
                                      <h3>¡Listo!</h3>Hemos enviado los datos
                                      relacionados a tu correo electrónico.
                                      Recuerda que puedes encontrarnos en
                                      nuestro{" "}
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={
                                          nivelEvent === "03"
                                            ? "https://admision.tec.mx/contact-hub-prepatec/home"
                                            : "https://admision.tec.mx/contact-hub/home"
                                        }
                                      >
                                        <b>Contact Hub</b>
                                      </a>
                                      , o ver más información en{" "}
                                      <a href="https://tec.mx/es">
                                        <b>Tec.mx</b>
                                      </a>
                                      .
                                    </p>
                                  </>
                                )}
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      </div>
                    ) : (
                      <form>
                        <Grid container spacing={1}>
                        </Grid>
                      </form>
                    )}

                    {/* FORMS */}
                    {mostrarFormulario && (
                      <div>
                        {mostrarFormulario === "formPapa" && (
                          <>
                            <div style={{ padding: "1%" }}>
                              Ya tenemos datos asociados a tu correo, pero como
                              padre o madre de familia. Para poder concluir el
                              registro, es necesario completar la información
                              del estudiante.
                            </div>

                            <br></br>
                            <FormTutor
                              Evento={evento}
                              ClCampus={claveCampus}
                              NivelEvento={nivelEvent}
                              EventoRegistrado={eventoRegistrado}
                              viweForm={handleForm}
                              InfoCampus={campusData}
                            />
                          </>
                        )}

                        {mostrarFormulario === "prospecto" && (
                          <>
                            <FormSend
                              Evento={evento}
                              ClCampus={claveCampus}
                              NivelEvento={nivelEvent}
                              EventoRegistrado={eventoRegistrado}
                              viweForm={handleForm}
                            />
                          </>
                        )}

                        {mostrarFormulario === "form" && (
                          <>
                            <h6>
                              Para concluir tu registro, completa los siguientes
                              datos.
                            </h6>
                            <br></br>
                            <Form
                              Evento={evento}
                              ClCampus={claveCampus}
                              NivelEvento={nivelEvent}
                              EventoRegistrado={eventoRegistrado}
                              viweForm={handleForm}
                              InfoCampus={campusData}
                            />
                          </>
                        )}
                      </div>
                    )}
                  </Grid>
                </Grid>
                <Grid item md={1} xs={1}></Grid>
              </Grid>
            </>
          )}
          <br></br>
          <br></br>
          <EventoDatos
            Evento={evento}
            Registrado={registrado}
            InfoCampus={campusData}
          />

          <br></br>
          <div style={{ marginTop: "5%", height: "1px" }}>
          <Footer></Footer>
          </div>
        </div>
      )}
    </div>
  );
}

export default Eventos;
